<template>
  <div class="index-main">
    <div class="swiper-container">
      <div class="index-swiper swiper-wrapper">
        <div class="swiper-slide  slide-item">
          <div class="slide-content">
            <div class="title">
              公司产品&nbsp;&nbsp;/&nbsp;&nbsp;可溶纤维类
              <div class="line"></div>
            </div>
            <div v-if="[0].includes(showIndex)" class="content-main2">
              <div class="item animated backInLeft" @click="toUrl('suolazhi')">
                <img src="/image/pro/suolazhi.png" alt="">
                <div class="desc">索拉纸</div>
              </div>
              <div class="item animated backInUp" @click="toUrl('suolakerongxianweiban')">
                <img src="/image/pro/suolakerongxianweiban.png" alt="">
                <div class="desc">索拉可溶纤维板</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('suolakerongxianweimian')">
                <img src="/image/pro/suolakerongxianweimian.png" alt="">
                <div class="desc">索拉可溶纤维棉</div>
              </div>
              <div class="item animated backInLeft" @click="toUrl('suolatan')">
                <img src="/image/pro/suolatan.png" alt="">
                <div class="desc">索拉毯</div>
              </div>
              <div class="item animated backInUp">
              </div>
              <div class="item animated backInRight">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="animate-more">
      <img src="@/assets/image/xiangxiazhanhang.png" alt="">
    </div>
  </div>
</template>
 
<script>
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import Swiper from 'swiper'
export default {
  // beforeRouteLeave(to, form, next) {
  //   window.removeEventListener('scroll', this.handleScroll, true)
  //   next()
  // },
  data() {
    return {
      showIndex: 0,
    }
  },
  created() {},
  mounted() {
    const that = this
    new Swiper('.swiper-container', {
      // pagination: '.swiper-pagination',
      direction: 'vertical',
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 3,
      // loop: true,
      mousewheelControl: true,
      nextButton: '.animate-more',
      onSlideChangeEnd: function (swiper) {
        that.showIndex = swiper.activeIndex
      },
    })
  },
  methods: {
    toUrl(key) {
      this.$router.push('/detail/index?p=' + key + '&type=kerongxianwei')
    },
  },
}
</script>
 
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}
.index-swiper {
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
  }
}
</style>